module.exports = __webpack_public_path__ + "img/panda2.5fbee47a.png";